import React from "react";
import {
  Text,
  Spacer,
  Image,
  Subtitle,
  Video,
  TextSmall,
} from "../dynamic.components";
import scalibility_table from "src/assets/images/scalibility/flow_rates.png";
import scalibility_1_4 from "src/assets/images/scalibility/1_4_flow_rates.png";
import scalibility_3_8 from "src/assets/images/scalibility/3_8_flow_rates.png";
import scalibility_1_2 from "src/assets/images/scalibility/1_2_flow_rates.png";
import scalibility_film from "src/assets/videos/scalability.mp4";
import flowrates_a from "src/assets/images/scalibility/flowrates_a.png";
import flowrates_b from "src/assets/images/scalibility/flowrates_b.png";
import flowrates_c from "src/assets/images/scalibility/flowrates_c.png";
import SubHotspots from "../Sub-hotspots";

export const SubHotspot_1_4: React.FC = () => {
  return (
    <>
      <Subtitle subtitle="Flow rates" />
      <Image
        images={[
          { src: scalibility_1_4, alt: "Flow rates 1/4", customWidth: "60%" },
          {
            src: flowrates_c,
            alt: "Flow rates",
            customWidth: "60%",
            footer:
              "Minimum working volume (recirculation line excl. filter) at different feed flow rates",
          },
        ]}
      />
      <Spacer />
    </>
  );
};

export const SubHotspot_3_8: React.FC = () => {
  return (
    <>
      <Subtitle subtitle='3/8" Flowkit' color="green" />
      <Subtitle subtitle="Flow rates" />
      <Image
        images={[
          { src: scalibility_3_8, alt: "Flow rates 3/8", customWidth: "60%" },
          {
            src: flowrates_b,
            alt: "Flow rates",
            customWidth: "60%",
            footer:
              "Minimum working volume (recirculation line excl. filter) at different feed flow rates",
          },
        ]}
      />
      <Spacer />
    </>
  );
};

export const SubHotspot_1_2: React.FC = () => {
  return (
    <>
      <Subtitle subtitle="Flow rates" />
      <Image
        images={[
          { src: scalibility_1_2, alt: "Flow rates 1/2", customWidth: "60%" },
          {
            src: flowrates_a,
            alt: "Flow rates",
            customWidth: "60%",
            footer:
              "Minimum working volume (recirculation line excl. filter) at different feed flow rates",
          },
        ]}
      />
      <Spacer />
    </>
  );
};

export const Scalabilty: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <Text text="ÄKTA readyflux™ flow kits come in three sizes (with two different end connections: TC and Readymate™ connectors. with quick installation, enabling easy conversion of the system to meet different process requirements. The system is suitable for UF/DF applications for 120 ml to 500 litre batch volumes" />
        <Spacer />
        <Text text="The 3/8 in. and 1/2 in. flow kits utilise a Quattroflow 1200 SU pump and the 1/4 in. utilises a Quattroflow 150 SU pump." />
        <Text text="The video below shows how to swap the pump heads on the system using the pump upgrade kit." />
        <Subtitle subtitle="Minimum working volume" />
        <Text text="The system’s minimum working volume represents the minimum volume of fluid(excluding filter) in the recirculation line required to operate the system at the desired crossflow rate without drawing air into the feed line For ÄKTA readyflux™ systems, the minimum working volume at different feed flow rates for a BSA solution of 5 g/L is displayed in the graph" />
        <Spacer x={1} />
        <Text text="Minimum working volume (recirculation line excl. filter) at different feed flow rates with (A) 1/2-IN, (B) 3/8-IN, and (C) 1/4-IN ÄKTA readyflux™ Flow Kits. Here, a BSA solution of 5 g/L was used." />
        <Spacer x={3} />

        <SubHotspots
          sublinkId="2-1"
          content={{ block: <SubHotspot_3_8 />, contentIndex: 0 }}
        />

        <Spacer x={2} />

        <Video src={scalibility_film} />
      </div>
    </>
  );
};
